// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"FeedbackOptions_buttonsWrapper__uXCnJ","buttons":"FeedbackOptions_buttons__Hyazn"};